import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/feedback-category',
  component: Layout,
  redirect: '/feedback-category/list',
  name: 'feedbackCategoryManagement',
  meta: {
    title: '反馈类别',
    icon: 'i-ep:folder',
    menu: false,
  },
  children: [
    {
      path: 'list',
      name: 'feedbackCategoryList',
      component: () => import('@/views/feedback/category/index.vue'),
      meta: {
        title: '反馈类别',
        icon: 'i-ep:folder',
      },
    },
    {
      path: 'add',
      name: 'feedbackCategoryAdd',
      component: () => import('@/views/feedback/category/add.vue'),
      meta: {
        title: '新增反馈类别',
        icon: 'i-ep:plus',
        menu: false,
      },
    },
    {
      path: 'edit/:id',
      name: 'feedbackCategoryEdit',
      component: () => import('@/views/feedback/category/edit.vue'),
      meta: {
        title: '编辑反馈类别',
        icon: 'i-ep:edit',
        menu: false,
      },
    },
  ],
}

export default routes
